import { useGlobalContext } from "../context/provider"
import { Modal,Input } from "antd"
import Login from "./Loginpart/Login"
import { useState } from "react"
import Regis from "./Loginpart/Regis"

const LoginModal = () => {
    const { isLoginModal ,setIsLoginModal,privateKey,typeLogin,setTypeLogin } = useGlobalContext()

    const CloseModal = () => {
        setIsLoginModal(false)
    }

    return(
        <Modal footer={false} width={1200} className="LoginModal" open={isLoginModal} onCancel={CloseModal} >
            <div className="grid grid-cols-12 w-full page-bg">
                <div className="hidden xl:block xl:col-span-7">
                    <img className="Login_img" src="https://eve-image.eveebook.com/image.eveebook/web_image/LoginImg.png"  alt="" />
                </div>
                <div className="col-span-12 xl:col-span-5 ">
                    {typeLogin == 'login' ? <Login/> : <Regis/> }
                </div>
            </div>
        </Modal>
    )
}

export default LoginModal